import { group } from "@angular/animations";
import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { VisibilityService } from "@services/visibility.service";
import { ActivatedRoute } from "@angular/router";
import { DomainConfigComponent } from "@app/domain-config.component";
import { PjudIndicatorsAccessService } from "@app/pjud-indicators/pjud-indicators-access.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {
  isTodosVisibilityItem,
  shouldShowUnreadMessageBadge,
  unreadMessageBadgeCount,
} from "@app/util/portal-chat-unread-badge";
import { NgxPermissionsService } from "ngx-permissions";
import { flujoEnPantalla, grupoAbiertoTrasPulsar } from "./sidebar.logic";
import { cuerpoTodosJuicios, mensajesSinLeerTodosJuicios, todosJuiciosVisible } from "@flows/requirement/juicios-todos/juicios-todos.logic";
import { RequirementByModuleService } from "@services/requirement-by-module.service";

const PERM_FLOWS = ["flows.menu.flows", "flows.admin"];

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  visibilities = [];
  visibilityGroupIdActived = 0;
  showMyRequirementsVisibilities: boolean;
  parametrosUrl: any = [];
  isUrlParams: boolean = false;

  visibilityGroupId: number;
  visibilityId: number;

  @Output() pending = new EventEmitter();
  @Output() visibilityIdSelected = new EventEmitter();
  @Output() showMyRequirementsActived = new EventEmitter<boolean>();
  @Input() visiData: Array<any>;
  @Input() activitiesBadget: number;

  visibilityIdActive: number = null;
  showCalendarOption: boolean = false;
  showPjudIndicatorsOption = false;
  totalTodosJuicios: number | null = null;
  private readonly destroy$ = new Subject<void>();

  constructor(
    public _visibility: VisibilityService,
    private activeRoute: ActivatedRoute,
    public domainConfigComponent: DomainConfigComponent,
    private pjudIndicatorsAccess: PjudIndicatorsAccessService,
    private cdr: ChangeDetectorRef,
    private permissions: NgxPermissionsService,
    private requirementByModule: RequirementByModuleService,
  ) {
    // Verificar si se debe mostrar la opción del calendario
    this.showCalendarOption = this.domainConfigComponent.configCalendar;
  }

  ngOnInit() {
    this.pjudIndicatorsAccess.canAccess()
      .pipe(takeUntil(this.destroy$))
      .subscribe((allowed) => {
        this.showPjudIndicatorsOption = allowed;
        this.cdr.markForCheck();
      });

    this.activeRoute.params.subscribe((params) => {
      console.log('ngOnInit sidebar');
      this.visibilityGroupId = parseInt(params["visibilityGroupId"]);
      this.visibilityId = parseInt(params["visibilityId"]);

      if (JSON.stringify(params) !== "{}") {
        this.isUrlParams = true;
      } else {
        this.isUrlParams = false;
      }
      this.showMyRequirementsVisibilities = false;
      this.loadVisibilities();
    });
  }

  /** Badge verde de mensajes: oculto si el conteo es 0. */
  showUnreadMessageBadge(count: unknown): boolean {
    return shouldShowUnreadMessageBadge(count);
  }

  unreadMessageBadgeLabel(count: unknown): number {
    return unreadMessageBadgeCount(count);
  }

  /** «Todos» dentro del grupo: no mostrar badge verde de mensajes. */
  isTodosVisibilityItem(item: { name?: string; defaultview?: boolean } | null | undefined): boolean {
    return isTodosVisibilityItem(item);
  }

  /** Badge verde de Todos los juicios: suma de los flujos de juicio. */
  get mensajesTodosJuicios(): number {
    return mensajesSinLeerTodosJuicios(this.visibilities);
  }

  showMyRequirements(value) {

    if (value) this.showMyRequirementsVisibilities = true;
    else this.showMyRequirementsVisibilities = false;

    this.loadVisibilities();

    this.showMyRequirementsActived.emit(value);
  }

  loadVisibilities() {

    const body = {
      myRequirements: this.showMyRequirementsVisibilities,
    };
    this._visibility.getVisibility(body).subscribe((data) => {

      const raw = data?.result ?? data;
      this.visibilities = Array.isArray(raw) ? raw : [];

      if (!this.visibilities.length) {
        this.pending.emit(null);
        return;
      }

      const pending = this.visibilities.find(
        (visibility) => visibility.name === "Pendientes"
      );
      this.visibilities = this.visibilities.filter(
        (visibility) => visibility.name !== "Pendientes"
      );
      this.visibilities.map((x) => {
        x.show = false;
      });
      this.cargarTotalTodosJuicios();
      if(!this.domainConfigComponent.configMyActivities && this.visibilities[0]){
        this.visibilities[0].show = true;
      }

      this.pending.emit(
        pending ? pending.items?.[0] : this.visibilities[0]?.items?.[0]
      );
      let visibilityIdReq = null;
      console.log('isUrlParams', this.isUrlParams);
      if (this.isUrlParams) {
        let visibility = this.visibilities.find(
          (i) => i.id === this.visibilityGroupId
        );
        let status = visibility?.items?.find(
          (item: any) => item.id == this.visibilityId
        );

        if (visibility && status) {
          let objReturn = {
            tipo: visibility.id,
            estado: status.id,
          };

          this.visibilityGroupIdActived = objReturn.tipo;
          visibilityIdReq = objReturn.estado;
        }
      } else {
        if(!this.domainConfigComponent.configMyActivities && this.visibilities[0]?.items?.[0]){
          this.visibilityGroupIdActived = this.visibilities[0].id;
          visibilityIdReq = this.visibilities[0].items[0].id;
        }else{
          this.visibilityGroupIdActived = 0;
          visibilityIdReq = 0;
        }

      }

      const menuIdVisibility = localStorage.getItem("id_visibility_req_menu");
      if (menuIdVisibility) {
        this.showMenu(+menuIdVisibility, true);
      }
    });
  }
  showMenu(id, soloAbrir = false) {

    let group_ = null;
    console.log('visibilityGroupIdActived', this.visibilityGroupIdActived);
    console.log('visibilityGroupId', id);
    if(this.visibilityGroupIdActived != 0 && this.visibilityGroupIdActived != id){
      localStorage.removeItem("requirement_list_page");
    }
    this.visibilityGroupIdActived = grupoAbiertoTrasPulsar(this.visibilityGroupIdActived, id, soloAbrir);
    if (this.visibilityGroupIdActived !== null) {
      console.log('showMenu sidebar');

      localStorage.setItem("id_visibility_req_menu", id);
      group_ = this.visibilities.filter((visibility) => visibility.id == id);
      if (!group_?.length || !group_[0]?.items?.length) {
        return;
      }
      let first_item_id = group_[0].items[0].id;
      const oldVisibilityId = +localStorage.getItem(
        "visibility_requirement_list"
      );

      if(oldVisibilityId && group_[0].items.find((item)=> item.id == oldVisibilityId)){
        this.sendVisibilityId(oldVisibilityId);
      }else{
        localStorage.removeItem("requirement_list_page");
        this.sendVisibilityId(first_item_id);
      }
    }
  }
  esFlujoEnPantalla(visibility): boolean {
    return flujoEnPantalla(visibility, this.visibilityIdActive);
  }

  getSectionBadge(section) {
    return section["items"].reduce(
      (total: Number, item: Object) =>
        item["allowCount"] ? total + item["count"] : total,
      0
    );
  }

  sendVisibilityId(id) {

    if(this.visibilityIdActive && this.visibilityIdActive !=0 && this.visibilityIdActive != +id){
      localStorage.removeItem("requirement_list_page");
    }
    this.visibilityIdActive = +id;
    localStorage.setItem("visibility_requirement_list", id);
    let sendVisibilityIdObj = {
      visibilityGroup: this.visibilityGroupIdActived,
      visibilityId: id,
    };
    this.visibilityIdSelected.emit(sendVisibilityIdObj);
  }


  showActivities(){
    localStorage.removeItem('id_visibility_req_menu');
    localStorage.removeItem('visibility_requirement_list');
    localStorage.removeItem('requirement_list_page');
    let sendVisibilityIdObj = {
      visibilityGroup: 0,
      visibilityId: 0,
    };
    this.visibilityGroupIdActived = 0;
    this.visibilityIdActive = 0;
    this.visibilityIdSelected.emit(sendVisibilityIdObj);
  }

  get showTodosJuiciosOption(): boolean {
    return todosJuiciosVisible(
      this.domainConfigComponent.isAllLawsuitsViewEnabled(),
      PERM_FLOWS.some((p) => !!this.permissions.getPermission(p)),
      this.visibilities,
    );
  }

  /** Mismo total que muestra la grilla: requerimientos distintos, no la suma de los badges de cada flujo. */
  private cargarTotalTodosJuicios(): void {
    if (!this.showTodosJuiciosOption) {
      this.totalTodosJuicios = null;
      return;
    }
    this.requirementByModule
      .getPage(cuerpoTodosJuicios({ pagina: 1, tamano: 1 }))
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (pagina) => {
          const total = Number(pagina?.recordsTotal);
          this.totalTodosJuicios = Number.isFinite(total) ? total : null;
        },
        error: () => (this.totalTodosJuicios = null),
      });
  }

  showTodosJuicios(){
    localStorage.removeItem('id_visibility_req_menu');
    localStorage.removeItem('visibility_requirement_list');
    localStorage.removeItem('requirement_list_page');
    this.visibilityGroupIdActived = -2;
    this.visibilityIdActive = -2;
    this.visibilityIdSelected.emit({ visibilityGroup: -2, visibilityId: -2 });
  }

  showCalendar(){
    localStorage.removeItem('id_visibility_req_menu');
    localStorage.removeItem('visibility_requirement_list');
    localStorage.removeItem('requirement_list_page');
    let sendVisibilityIdObj = {
      visibilityGroup: -1,
      visibilityId: -1,
    };
    this.visibilityGroupIdActived = -1;
    this.visibilityIdActive = -1;
    this.visibilityIdSelected.emit(sendVisibilityIdObj);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Vuelve a traer conteos del menú de flujos (Equipo/Propios) sin resetear
   * la sección expandida ni reemitir el flujo seleccionado. Útil tras eliminar
   * o carga masiva, cuando la grilla se refresca pero el árbol quedaba desactualizado.
   */
  refreshFlowCounts(): void {
    const body = {
      myRequirements: this.showMyRequirementsVisibilities,
    };
    this._visibility.getVisibility(body).subscribe((data) => {
      const all = Array.isArray(data?.result) ? data.result : Array.isArray(data) ? data : [];
      if (!all.length) {
        return;
      }
      const pending = all.find((v) => v.name === "Pendientes");
      this.visibilities = all.filter((v) => v.name !== "Pendientes");
      this.visibilities.forEach((x) => {
        if (x.show === undefined) {
          x.show = false;
        }
      });
      this.cargarTotalTodosJuicios();
      this.pending.emit(
        pending
          ? pending.items?.[0]
          : this.visibilities[0]?.items?.[0]
      );
    });
  }

}
